<template>
  <div class="content">
      <div class="row">
        <div class="col-sm-12 col-md-4">
          <a data-toggle="collapse" href="#filter" role="button" aria-expanded="false" aria-controls="filter">
            {{ $t('app.filter') }}
          </a>
        </div>
        <div class="col-sm-12 col-md-8">
          <div class="datatable_filter float-right">
            <div class="row">
              <div class="col" v-if="permissions.indexOf('archive-payments') != -1">
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="showNextContactToday"
                    v-model="filter.archive"
                    @change="fetchPayments"
                    true-value="1"
                    false-value="0"
                  >
                  <label class="form-check-label" for="showNextContactToday">
                    {{ $t('app.show_archive') }}
                  </label>
                </div>
              </div>
              <div class="col">
                <label>
                  <select v-model="tableData.length" @change="fetchPayments()" class="form-control form-control-sm">
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                  </select>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="collapse" id="filter">
        <div class="card card-body mb-3">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                    <label for="debt_statuses" class="col-form-label">{{ $t('field.status') }}</label>
                    <select class="form-control form-control-sm" id="debt_statuses" v-model="filter.confirmed">
                      <option selected value="">{{ $t('field.any') }}</option>
                      <option value="false">{{ $t('payments.not_confirmed') }}</option>
                      <option value="1">{{ $t('payments.confirmed') }}</option>
                    </select>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                    <label class="col-form-label">{{ $t('field.user') }}</label>
                    <select class="form-control form-control-sm" v-model="filter.user_id">
                      <option selected="true" value="">{{ $t('field.any') }}</option>
                      <option v-for="user in adminListUsers" :value="user.id" :key="user.id">
                        {{ user.fullname }}
                      </option>
                    </select>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="col-form-label">{{ $t('field.contragent') }}</label>
                  <select class="form-control form-control-sm" v-model="filter.contragent_id">
                    <option selected="true" value="">{{ $t('field.any') }}</option>
                    <option v-for="contragent in adminListContragents" :value="contragent.id" :key="contragent.id">
                      {{ contragent.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="col-form-label">{{ $t('payments.payment_date') }}</label>
                  <div class="input-group input-group-sm">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="datestart">C</span>
                    </div>
                    <input type="date" class="form-control form-control-sm" aria-label="Small" v-model="filter.period_start_date" aria-describedby="datestart" />
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="col-form-label">{{ $t('payments.payment_date') }}</label>
                  <div class="input-group input-group-sm">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="dateend">По</span>
                    </div>
                    <input type="date" class="form-control form-control-sm" aria-label="Small" v-model="filter.period_end_date" aria-describedby="dateend" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="text-center">
                  <div class="btn-group" role="group" aria-label="btnGroup1">
                    <button class="btn btn-primary" @click="fetchPayments()">
                      <font-awesome-icon icon="search" /> {{ $t('field.find') }}
                    </button>
                    <button class="btn btn-danger" @click="resetForm()">
                      <font-awesome-icon icon="times" /> {{ $t('field.reset') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>

      <div class="block block-rounded block-fx-shadow mb-3">
        <div class="block-header">
          <h3 class="block-title">{{ $t('payments.index') }} {{pagination.total ? '(' + pagination.total + ')': '' }}</h3>
        </div>
        <div class="table-responsive">
          <datatable class="m-0" :columns="columns" :sortKey="sortKey" :sortOrders="sortOrders" :loading="loadPayments" @sort="sortBy" >
            <tbody>
                <tr v-for="(payment, index) in payments" :key="payment.id">
                  <td>{{index+1}}</td>
                  <td>{{payment.debt ? payment.debt.number : '' }}</td>
                  <td>{{payment.user ? payment.user.lastname: '' }} {{payment.user ? payment.user.firstname: '' }}</td>
                  <td>{{payment.amount}}</td>
                  <td>{{payment.payment_date | dateFormat}}</td>
                  <td>{{payment.confirmed ? $t('payments.confirmed') : $t('payments.not_confirmed') }}</td>
                  <td>
                    <span v-if="payment.receipt_number">
                      <strong>
                        {{ $t('payments.receipt_number') }}:
                      </strong>
                      {{payment.receipt_number}}
                    </span><br>
                    <span v-if="payment.date_receipt">
                      <strong>
                        {{ $t('payments.date_receipt') }}:
                      </strong>
                      {{payment.date_receipt | dateFormat}}
                    </span>
                  </td>
                  <td>
                    <div class="btn-group" v-if="!payment.deleted_at">
                      <button
                        v-if="!payment.confirmed && permissions.indexOf('reject-payments') != -1"
                        @click.prevent="confirm(payment.id)"
                        class="btn btn-outline-success"
                        :disabled="payment.id == processid"
                        title="Подтвердить"
                        >
                          <i v-if="payment.id == processid" class="fa fa-spinner fa-pulse"></i>
                          <i v-if="payment.id != processid"  class="fa fa-check"></i>
                      </button>
                      <button
                        v-if="payment.confirmed && permissions.indexOf('confirm-payments') != -1"
                        @click.prevent="reject(payment.id)"
                        class="btn btn-outline-danger"
                        :disabled="payment.id == processid"
                        title="Отменить подтверждение"
                        >
                          <i v-if="payment.id == processid" class="fa fa-spinner fa-pulse"></i>
                          <i v-if="payment.id != processid" class="fa fa-times" aria-hidden="true"></i>
                      </button>
                      <button
                        @click.prevent="handleDelete(payment.id)"
                        class="btn btn-outline-danger"
                        :disabled="payment.id == processid"
                        title="Удалить"
                        v-if="permissions.indexOf('delete-payments') != -1"
                        >
                          <font-awesome-icon :icon="['far', 'trash-alt']" />
                      </button>
                    </div>
                    <button
                      v-if="payment.deleted_at && permissions.indexOf('restore-payments') != -1"
                      @click.prevent="restorePayment(payment.id)"
                      class="btn btn-outline-success"
                      :disabled="payment.id == processid"
                      title="Восстановить"
                      >
                        <span v-if="payment.id != processid">{{ $t('buttons.restore') }}</span>
                        <i v-if="payment.id == processid" class="fa fa-spinner fa-pulse"></i>
                    </button>
                  </td>
                </tr>
            </tbody>
          </datatable>
        </div>
      </div>

      <pagination :pagination="pagination" :offset="4" @paginate="fetchPayments()"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      payments: [],
      columns: [
        { label: '#', name: 'index', disableOrder: true },
        { label: this.$t('debts.number_short'), name: 'number' },
        { label: this.$t('field.user'), name: 'users.lastname' },
        { label: this.$t('payments.amount'), name: 'amount' },
        { label: this.$t('payments.payment_date'), name: 'payment_date' },
        { label: this.$t('field.status'), name: 'status' },
        { label: this.$t('payments.receipt'), name: 'receipt' },
        { label: this.$t('app.action'), name: 'action' },
      ],
      sortKey: 'name',
      sortOrders: {},
      tableData: {
        draw: 0,
        length: 10,
        search: '',
        column: 4,
        dir: 'asc',
      },
      filter: {
        confirmed: '',
        contragent_id: '',
        user_id: '',
        period_start_date: '',
        period_end_date: '',
        archive: '',
      },
      pagination: {
        current_page: 1,
      },
      isProcessing: false,
      processid: '',
      loadPayments: false,
    };
  },
  computed: {
    ...mapGetters([
      'adminListUsers',
      'adminListContragents',
      'permissions',
    ]),
  },
  mounted() {
    this.fetchPayments();
    this.GET_ADMIN_LIST_USERS();
    this.GET_ADMIN_LIST_CONTRAGENTS();
    this.columns.forEach((column) => {
      this.sortOrders[column.name] = -1;
    });
  },
  methods: {
    ...mapActions([
      'GET_ADMIN_LIST_USERS',
      'GET_ADMIN_LIST_CONTRAGENTS',
    ]),
    fetchPayments() {
      this.loadPayments = true;
      this.tableData.draw += 1;
      const requests = { ...this.filter, ...this.tableData };
      window.axios.get(`/admin/payments?page=${this.pagination.current_page}`, { params: requests })
        .then((res) => {
          if (this.tableData.draw === res.data.draw) {
            this.payments = res.data.payments.data;
            this.pagination = this.laraPaginate(res.data.payments);
          } else {
            console.log('failed');
          }
          this.loadPayments = false;
        });
    },

    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.column = this.getIndex(this.columns, 'name', key);
      this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc';
      this.fetchPayments();
    },

    confirm(id) {
      this.processid = id;
      window.axios.get(`/admin/payments/${id}/confirm`)
        .then((res) => {
          if (res.status === 204) {
            this.fetchPayments();
          }
          this.processid = '';
        });
    },

    reject(id) {
      this.processid = id;
      window.axios.get(`/admin/payments/${id}/reject`)
        .then((res) => {
          if (res.status === 204) {
            this.fetchPayments();
          }
          this.processid = '';
        });
    },

    resetForm() {
      this.filter.status_id = '';
      this.filter.contragent_id = '';
      this.filter.confirmed = '';
      this.filter.user_id = '';
      this.filter.period_start_date = '';
      this.filter.period_end_date = '';
      this.pagination.current_page = 1;
      this.fetchPayments();
    },

    handleDelete(id) {
      window.Swal.fire({
        title: this.$t('alerts.are_you_sure'),
        text: this.$t('alerts.want_to_delete'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('alerts.delete_it'),
        cancelButtonText: this.$t('field.cancel'),
      }).then((result) => {
        if (result.value) {
          this.deletePayment(id);
        }
      });
    },

    deletePayment(id) {
      this.processid = id;
      window.axios.delete(`/admin/payments/${id}`)
        .then((res) => {
          if (res.status === 204) {
            window.Swal.fire(this.$t('alerts.success'), 'Успешно удалено!', 'success');
            this.fetchPayments();
          }
          this.processid = '';
        });
    },

    restorePayment(id) {
      this.processid = id;
      window.axios.put(`/admin/payments/${id}/restore`)
        .then((res) => {
          if (res.status === 202) {
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.fetchPayments();
          }
          this.processid = '';
        });
    },
  },
};
</script>
